import React from "react";
import { useTranslation } from "react-i18next";
import { SettingsError01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { useAuthContext } from "../../_helper/Auth";
import { Button } from "react-bootstrap";

export const SomethingWentWrong = () => {
  const { t } = useTranslation();
  const { setIsInternelServerError } = useAuthContext();

  return (
    <div className="error-wrapper something-went-wrong">
      <div className="error-container">
        {/* Error Icon */}
        <div className="error-icon-container">
          <div className="error-icon">
            <HugeiconsIcon
              size={120}
              color="currentColor"
              className="error-svg"
              icon={SettingsError01Icon}
            />
          </div>
        </div>

        {/* Error Content */}
        <div className="error-content">
          <h1 className="error-title">{t("SOMETHING_WENT_WRONG")}</h1>

          <p className="error-description">
            {t(
              "SOMETHING_WENT_WRONG_DESCRIPTION",
              "We're sorry, but something unexpected happened. Our team has been notified and is working to fix the issue."
            )}
          </p>

          <Button
            onClick={() => setIsInternelServerError(false)}
            className="btn btn-primary"
          >
            {t("GO_BACK")}
          </Button>
        </div>
      </div>
    </div>
  );
};
